import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class ShortTermRentalConfig extends Model {
  [Type] = 'short-term-rental-config' as const;

  @attr('number') declare priceRangeLimitMax: number;
  @attr('number') declare priceRangeLimitMin: number;
  @attr('number') declare radiusLimit: number;
}
